import * as React from 'react'
import {Box, Typography} from "@mui/material";


export default function skuColumn() {
	return {
		name: 'skuName', label: 'Product Name',
		options: {
			headerAlign: 'left',
			setCellProps: () => ({ sx: { minWidth: '300px' }}),
			customBodyRowRenderLite: (value, { category, brand, ean }) => <Box>
				<Typography variant="caption">
					{value}
				</Typography>
				<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
					Category: {category}
				</Typography>
				<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
					Brand: {brand}
				</Typography>
				{ !!ean && <Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
					EAN: {ean}
				</Typography> }
			</Box>
		}
	}
}